import { DatePicker } from 'antd'
import moment from 'moment'
import React, { useRef } from 'react'
import { AssetStore } from '../../../assets/AssetsStore'
import styles from './index.module.scss'

function DatePickers({ onChange, value, style, disableFuture, disablePast,disabled }) {

    const datePick = useRef()


    function handleClick() {
        console.log(datePick);
        datePick?.current?.focus()
    }

    const blockPast = (current) => {

        if (disableFuture) {
            return disableFuture && moment().add(0, 'days') <= current
        }
        else if (disablePast) {
            return disablePast && moment().add(-1, 'days') >= current
        }



    }

    console.log("value",value)
    return (
        <div className={styles.datePicker}>

            <DatePicker
                disabled={disabled ?? false}
                disabledDate={blockPast}
                style={{ ...style }}
                value={value ? moment(value) : undefined}
                format={"DD-MM-YYYY"}
                onChange={(moment, date) => { onChange && onChange(moment, date) }}
                allowClear={true}
                suffixIcon={<img src={AssetStore.managePrescription.calander} alt="" />}
                getPopupContainer={trigger => trigger.parentNode}
            />
            {/* <img onClick={() => { handleClick() }} src={AssetStore.managePrescription.calander} alt="" /> */}
        </div>
    )
}

export default DatePickers